import { render, staticRenderFns } from "./GetAllForms.vue?vue&type=template&id=73a15238&"
import script from "./GetAllForms.vue?vue&type=script&lang=js&"
export * from "./GetAllForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports